import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '@/layouts/dashboard';
import AuthGuard from '@/guards/AuthGuard';
import RoleBasedGuard from '@/guards/RoleBasedGuard';
import { TransactionsList } from '../pages';
import { PATH_TRANSACTIONS } from './paths';

const TRANSACTION_ROUTES = [
  {
    path: PATH_TRANSACTIONS.list,
    roles: ['transactions.view'],
    component: <TransactionsList />,
    index: true,
  },
];

export const TransactionsRoutes = () => (
  <Routes>
    <Route
      element={
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      }
    >
      {TRANSACTION_ROUTES.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          index={route.index}
          element={
            <RoleBasedGuard roles={route.roles}>
              {route.component}
            </RoleBasedGuard>
          }
        />
      ))}
    </Route>
  </Routes>
);
